@if(tokenSetFlg) {
<router-outlet></router-outlet>
}@else{
<div>認証中...</div>
}
<router-outlet name="token"></router-outlet>
